/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class TxParamSetupReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'maxeirp')
          .add('FE_EMPTY', 'uldwelltime')
          .add('FE_EMPTY', 'dldwelltime')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeMaxeirp = this.handleChangeMaxeirp.bind(this);
    this.handleChangeULDwellTime = this.handleChangeULDwellTime.bind(this);
    this.handleChangeDLDwellTime = this.handleChangeDLDwellTime.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        const { deviceId, getTxSize, getMacLog } = this.props;
        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors });
      }
    }
  }

  handleChangeMaxeirp(e) {
    const maxeirp = e.target.value.trim();
    this.setState({ maxeirp });

    const { errors } = this.state;

    if (maxeirp === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'maxeirp') });
      return;
    }
    if (!isInteger(maxeirp, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'maxeirp') });
      return;
    }
    this.setState({ errors: errors.remove('maxeirp') });
  }

  handleChangeULDwellTime(e) {
    const uldwelltime = e.target.value.trim();
    this.setState({ uldwelltime });

    const { errors } = this.state;

    if (uldwelltime === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'uldwelltime') });
      return;
    }
    if (!isInteger(uldwelltime, { min: 0, max: 1 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'uldwelltime') });
      return;
    }
    this.setState({ errors: errors.remove('uldwelltime') });
  }

  handleChangeDLDwellTime(e) {
    const dldwelltime = e.target.value.trim();
    this.setState({ dldwelltime });

    const { errors } = this.state;

    if (dldwelltime === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'dldwelltime') });
      return;
    }
    if (!isInteger(dldwelltime, { min: 0, max: 1 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'dldwelltime') });
      return;
    }
    this.setState({ errors: errors.remove('dldwelltime') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { maxeirp, uldwelltime, dldwelltime } = this.state;
    sendCmd(deviceId, {
      maxeirp,
      uldwelltime,
      dldwelltime,
    });
  }

  render() {
    const {
      sentStatus = '',
      maxeirp = '',
      uldwelltime = '',
      dldwelltime = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('maxeirp') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('txparamsetupreq.maxeirp')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={maxeirp}
              placeholder={this.intlMsg.msg('txparamsetupreq.maxeirp.placeholder')}
              onChange={this.handleChangeMaxeirp}
            />
            <ControlTips
              show={submitted && errors.has('maxeirp')}
              message={this.intlMsg.errorMsg(errors.get('maxeirp'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('uldwelltime') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              UpLink DwellTime
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={uldwelltime}
              placeholder={this.intlMsg.msg('txparamsetupreq.uldwelltime.placeholder')}
              onChange={this.handleChangeULDwellTime}
            />
            <ControlTips
              show={submitted && errors.has('uldwelltime')}
              message={this.intlMsg.errorMsg(errors.get('uldwelltime'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('dldwelltime') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              DownLink DwellTime
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={dldwelltime}
              placeholder={this.intlMsg.msg('txparamsetupreq.dldwelltime.placeholder')}
              onChange={this.handleChangeDLDwellTime}
            />
            <ControlTips
              show={submitted && errors.has('dldwelltime')}
              message={this.intlMsg.errorMsg(errors.get('dldwelltime'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

TxParamSetupReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendTxParamSetupReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendTxParamSetupReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TxParamSetupReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/TxParamSetupReq.jsx